import { IconWarningRegular, skinVars, useWindowSize } from '@telefonica/mistica';
import React from 'react';
import './index.scss';
import '../../translations/i18n';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Cell,
    CartesianGrid,
    LabelList,
    ReferenceLine,
    ResponsiveContainer,
} from 'recharts';
import { IBillsItem } from '../../models/Bills.interfaces';

export interface BillsBarChartData {
    data: any;
    onHandleMonthActive: (item: IBillsItem, index: number) => void;
    active: number;
}

export const BillsBarChart: React.FC<BillsBarChartData> = ({
    data,
    onHandleMonthActive,
    active,
}: BillsBarChartData) => {
    const dataTest = data;
    const size = useWindowSize();

    const CustomLabelTop = (props: any) => {
        const { x, y, width, index } = props;
        const radius = size.width >= 1024 ? 16 : 10;
        const isError = dataTest[index].debt > 0 ? skinVars.colors.error : skinVars.colors.brand;
        if (dataTest[index].debt > 0 || dataTest[index].payment) {
            return (
                <svg x={x - (size.width >= 1024 ? 12 : 8) + width / 2} y={y - radius - (size.width >= 1024 ? 12 : 10)}>
                    <IconWarningRegular color={isError} size={size.width >= 1024 ? 24 : 16} />
                </svg>
            );
        } else {
            return <span />;
        }
    };

    const handleMonthActive = (index: number) => onHandleMonthActive(dataTest[index], index);

    const isDebt = (active: number, index: number, debt: number) => {
        const _isDebt = debt > 0 ? skinVars.colors.errorLow : skinVars.colors.barTrack;
        const _isDebtSelected = debt > 0 ? skinVars.colors.error : skinVars.colors.brand;
        return active === index ? _isDebtSelected : _isDebt;
    };

    return (
        <div className='bills-bar-chart' style={{ width: '100%', height: size.width >= 1220 ? '220px' : '148px' }}>
            <ResponsiveContainer>
                <BarChart data={data}>
                    <>
                        <CartesianGrid
                            stroke={skinVars.colors.barTrack}
                            strokeDasharray={3}
                            strokeWidth={0.4}
                            vertical={false}
                        />
                        <YAxis
                            className='bill-bar-chart-currency'
                            width={26}
                            stroke={skinVars.colors.barTrack}
                            minTickGap={20}
                            axisLine={false}
                            unit='€'
                        />
                        <ReferenceLine y={0} stroke={skinVars.colors.barTrack} />
                    </>
                    <XAxis y={100} dataKey='monthSort' stroke={skinVars.colors.barTrack} />
                    <Bar
                        dataKey='count'
                        fill={skinVars.colors.barTrack}
                        radius={size.width >= 1024 ? [16, 16, 0, 0] : [8, 8, 0, 0]}
                        barSize={12}
                        minPointSize={5}
                    >
                        <LabelList content={CustomLabelTop} />
                        {dataTest &&
                            dataTest.map((item: any, index: any) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={isDebt(active, index, item?.debt)}
                                    onClick={() => handleMonthActive(index)}
                                />
                            ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default BillsBarChart;
